"use client";

import { usePricelist } from "@/pricelist/PricelistContext";
import { Tag } from "@cappelendamm/design-system/react";
import { getPriceOffer, type PriceList } from "@/products/pricing";

export function PricelistTag({
  count,
  originalItemPrice,
  subjectToVAT,
  pricelists,
}: {
  count: number;
  originalItemPrice: number | null | undefined;
  subjectToVAT: boolean | null | undefined;
  pricelists?: PriceList[] | null | undefined;
}) {
  const { applicablePricelists } = usePricelist();
  const safePricelists = Array.isArray(pricelists) ? pricelists : [];

  const price = getPriceOffer({
    originalItemPrice,
    subjectToVAT,
    priceLists: safePricelists.filter((pricelist) =>
      applicablePricelists?.some(
        (applicable) => applicable.node?.identifier === pricelist.identifier,
      ),
    ),
  });

  if (!price.current) return null;

  return <Tag variant="promoted">{`${count} for ${price.current},-`}</Tag>;
}
